import { MouseEvent, ReactNode } from 'react';
import Text from '@atoms/Text/Text';
import { StyledLabel } from './Label.styles';

export type LabelType = 'mixed' | 'news' | 'mixAndMatch';

interface Props {
  onClick?: (event: MouseEvent<HTMLSpanElement>) => void;
  className?: string;
  children: ReactNode;
  variant: LabelType;
}

const Label = ({ onClick, className, children, variant }: Props) => {
  return (
    <StyledLabel onClick={onClick} $variant={variant} className={className}>
      <Text type="label" size="xsmall" element="span">
        {children}
      </Text>
    </StyledLabel>
  );
};

export default Label;
